import { useState, useContext, useEffect } from 'react'
import CustomButton from '../ui/CustomButton'
import TablaNuevoComprobante from '../views/dashboard/MiContador/Comprobante/TablaNuevoComprobante'
import { optionTipoComprobante, optionEstado } from '../data/dataComprobante'
import { OrganizationAPI } from '../../../api/organization.api'
import GlobalContext from '../../../context/global-context'
import FilterDateControl from '../table/FilterDateControl'
import FilterControl from '../table/FilterControl'
import ResizableModal from '../ui/ResizableModal'
import { Title } from '../ui'

const MAX_TOTAL = 2_000_000_000

const ModalNuevoMiContador = ({ openNuevoComprobante, setOpenNuevoComprobante,setSwitchGetData }) => {
  const [totalDebe, setTotalDebe] = useState(0)
  const [totalHaber, setTotalHaber] = useState(0)
  //const [switchDate, setSwitchDate] = useState(true)
  const todayISO = new Date().toISOString().split('T')[0]
  const [selectedDate, setSelectedDate] = useState(todayISO)
  const [tipoComprobante, setTipoComprobante] = useState('')
  const [estadoComprobante, setEstadoComprobante] = useState('')
  const [libros, setLibros] = useState([])
  const organizationAPI = new OrganizationAPI()
  const { ui, currentBusiness } = useContext(GlobalContext)
  const { blockedPeriods } = ui
  const [glosa, setGlosa] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [isAgregarEnabled, setIsAgregarEnabled] = useState(false)
  const [isGuardarBorradorEnabled, setIsGuardarBorradorEnabled] = useState(false)
  const [, setListaAuxiliar] = useState([])

  useEffect(() => {
    if (parseInt(estadoComprobante) === 1) {
      setIsAgregarEnabled(true)
      setIsGuardarBorradorEnabled(false)
    } else if (parseInt(estadoComprobante) === -6) {
      setIsAgregarEnabled(false)
      setIsGuardarBorradorEnabled(true)
    } else {
      setIsAgregarEnabled(false)
      setIsGuardarBorradorEnabled(false)
    }
  }, [estadoComprobante])

  const handleClose = () => setOpenNuevoComprobante(false)

  const getDateToUse = () => selectedDate

  const handleDateChange = value => {
    const newDate = new Date(value)
    const today = new Date()
    const minDate = new Date('2024-01-01')

    const selectedMonth = `${newDate.getFullYear()}-${String(
      newDate.getMonth() + 1
    ).padStart(2, '0')}`

    const isBlocked = blockedPeriods.some(
      period => period.periodo === selectedMonth && period.estado
    )

    if (!isBlocked && newDate >= minDate && newDate <= today) {
      setSelectedDate(value)
      setErrorMessage('')
    } else {
      setErrorMessage('La fecha seleccionada pertenece a un periodo bloqueado.')
    }
  }

  const isDateDisabled = date => {
    const selectedMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
    return blockedPeriods.some(period => period.periodo === selectedMonth && period.estado)
  }

  const handleTextareaChange = e => {
    const value = e.target.value
    if (value.length > 50) {
      setErrorMessage('Máximo 50 caracteres permitidos')
    } else {
      setErrorMessage('')
    }
    setGlosa(value)
  }

  const formatFecha = fecha => {
    const [day, month, year] = fecha.split('-')
    return `${year}-${month}-${day}`
  }

  const handleAddComprobante = async () => {
    if (parseInt(estadoComprobante) === 1) {
      if (
        !tipoComprobante ||
        !glosa ||
        totalDebe === 0 ||
        totalHaber === 0 ||
        totalDebe !== totalHaber
      ) {
        setErrorMessage('Todos los campos son obligatorios y los totales deben coincidir.')
        return
      }
    }
    //const auxiliares = listaAuxiliar || []
    const folio = libros
      .flatMap(row => row.auxiliar?.map(auxiliar => auxiliar.folio) || [])
      .filter(value => value !== null && value !== undefined && String(value).trim() !== '')
      .map(value => Number(value))
      .find(value => Number.isFinite(value))

    const payload = {
      fecha: getDateToUse(),
      tipo: parseInt(tipoComprobante),
      estado: parseInt(estadoComprobante),
      glosa: glosa,

      ...(folio !== undefined && { folio }),

      libros: libros.map(row => ({
        cuentaContableId: parseInt(row.cuentaContableId),
        glosa: row.glosa || glosa,
        debe: parseFloat(row.debe) || 0,
        haber: parseFloat(row.haber) || 0,
        centroCosto: row.centroCostos || null,
        sucursal: row.sucursal || null,
        rut: row.auxiliar?.map(a => a.rut).join(', ') || null,
        name: row.auxiliar?.map(a => a.razonSocial).join(', ') || null,
      })),

      vencimiento: libros.flatMap(row =>
        row.auxiliar?.map(a =>
          a.fechaVencimiento ? formatFecha(a.fechaVencimiento) : null
        ) || []
      )
    }
    try {
      ui.setLoader({ visible: true })
      const response = await organizationAPI.postComprobante(payload, currentBusiness.id)
      console.info(response)
      setOpenNuevoComprobante(false)
      setSwitchGetData(true)
    } catch (error) {
      console.error('Error al agregar comprobante:', error.message)
    } finally {
      ui.setLoader({ visible: false })
    }
  }
  return (
    <ResizableModal open={open} onClose={handleClose}
    footer={
      <>
        {errorMessage && <p className='text-red-500 text-sm mt-1'>{errorMessage}</p>}
          <>
            <CustomButton className='rounded-full' color='accent2' title='AGREGAR'
               disabled={
                !isAgregarEnabled ||
                totalDebe !== totalHaber ||
                (totalDebe === 0 && totalHaber === 0) ||
                totalDebe > MAX_TOTAL ||
                totalHaber > MAX_TOTAL
              }
              onClick={handleAddComprobante}
            />
            <CustomButton className='rounded-full' color='accent2' title='GUARDAR BORRADOR' disabled={!isGuardarBorradorEnabled} onClick={handleAddComprobante}/>
            <CustomButton  className='rounded-full' color='primary' title='DESCARTAR' onClick={handleClose} />
          </>
      </>}
    >
          <> 
            <div className='flex justify-between items-center p-4'>
              <Title className='text-3xl font-sans'>Nuevo Comprobante</Title>
            </div>
            <div className='p-4 mt-2 bg-white rounded-lg'>
              <div className='flex flex-wrap items-center gap-4 mt-4'>
                <FilterDateControl
                  label="Fecha"
                  value={selectedDate}
                  onChange={handleDateChange}
                  disabled={!setSwitchGetData}
                  isDateDisabled={isDateDisabled}
                />
                <FilterControl
                  label='Tipo Comprobante'
                  value={tipoComprobante}
                  options={optionTipoComprobante}
                  onChange={value => setTipoComprobante(parseInt(value))}
                  required={parseInt(estadoComprobante) === 1}
                />
                <FilterControl
                  label='Estado'
                  value={estadoComprobante}
                  options={optionEstado}
                  onChange={setEstadoComprobante}
                  MenuProps={{ getContentAnchorEl: null }}
                />
              </div>
              <div className='mt-4'>
                <label className='block text-sm font-sans font-medium text-gray-700'>Glosa</label>
                <textarea
                  className='mt-1 w-full border-gray-300 rounded-lg shadow-sm font-sans'
                  rows='1'
                  value={glosa}
                  onChange={handleTextareaChange}
                  maxLength={50}
                  required={parseInt(estadoComprobante) === 1}
                />
                <p className='text-xs font-sans'>{glosa.length}/50</p>
              </div>
              <TablaNuevoComprobante
                setTotalDebe={setTotalDebe}
                setTotalHaber={setTotalHaber}
                totalDebe={totalDebe}
                totalHaber={totalHaber}
                setLibros={setLibros}
                glosaPrincipal={glosa}
                isRequired={parseInt(estadoComprobante) === 1}
                setListaAuxiliar={setListaAuxiliar}
                context='nuevo'
              />
              
            </div>
          </>
    </ResizableModal>
  )
}

export default ModalNuevoMiContador
